require('../../modules/es6.string.iterator');
require('../../modules/es6.array.from');
module.exports = require('../../modules/_core').Array.from;



//////////////////
// WEBPACK FOOTER
// ./src/frontend-lib/~/core-js/library/fn/array/from.js
// module id = 4QXj
// module chunks = 0